import { Component } from '@angular/core';

@Component({
    selector: 'ui-container',
    templateUrl: './container.component.html',
    styleUrls: ['./container.component.scss'],
    standalone: false
})
export class ContainerComponent {}
